
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import TemplatesCards from '@/Shared/TemplatesCard';
const meta = {};
const slug = '_how';
const tableOfContents = [];

const layoutProps = {
  meta,
slug,
tableOfContents
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`CREATE a FREE BOOKING Website in just few steps. `}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">
        <p parentName="li">{`Sign Up with a `}<a parentName="p" {...{
            "href": "https://tradly.app/signup"
          }}>{`free account`}</a></p>
        <div class="relative">
       <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/signup-tradly.png" />
     </div>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select any templates`}</p>
      </li>
    </ol>
    <TemplatesCards template_id={[11103, 10463]} title={'Event Booking Templates'} isShowBtn={false} mdxType="TemplatesCards" /> 
    <ol {...{
      "start": 3,
      "role": "list"
    }}>
      <li parentName="ol">
        <p parentName="li">{`Customise the styling using Simple `}<a parentName="p" {...{
            "href": "https://tradly.app/editor"
          }}>{`Website Editor`}</a></p>
        <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/customisation-store.png" />
        </div>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Create Events with images, descriptions and other optional rules `}</p>
      </li>
    </ol>
    <ol {...{
      "start": 5,
      "role": "list"
    }}>
      <li parentName="ol">{`Optional `}{`[Add Payment Gateways]`}
        <div class="relative">
       <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/payment-store.png" />
     </div>
      </li>
    </ol>
    <p>{`That’s it. You can start receiving bookings. `}</p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
